// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-profile {
  min-height: calc(100vh - 24.3rem);
}

@media (max-width: 991.98px) {
  .section-profile-cover {
    height: 300px;
  }
}
.btn-disconnect {
  background-color: #5d43ae;
  color: #fff;
}

.disabilities_container {
  font-size: 1.5rem;
}

.headings {
  letter-spacing: 1px;
  border-radius: 5px;
  padding: 1rem 0;
  font-weight: 500;
  margin-top: 1.5rem;
  margin-bottom: 0.5rem;
  background-color: #a998d7;
  color: #000;
}

.badge-secondary {
  color: #fff;
  background-color: #6449b3;
}

td.info-cell {
  display: flex;
  justify-content: center;
}

.check-icon {
  color: green;
}

.error-icon {
  color: #f44336;
}

.map-card {
  border-bottom: solid 2px #3f51b5;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.no-caretaker-container {
  min-height: 116px;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 0.625px;
  flex-grow: 1;
}

.map-small {
  min-height: 300px;
}

.map-expanded {
  min-height: 390px;
}`, "",{"version":3,"sources":["webpack://./src/app/nonAdmin/profile/display/display.component.scss"],"names":[],"mappings":"AAOA;EACI,iCAAA;AANJ;;AASA;EACI;IACI,aAAA;EANN;AACF;AAcA;EACI,yBAAA;EACA,WAAA;AAZJ;;AAeA;EACI,iBAAA;AAZJ;;AAeA;EAEI,mBAAA;EACA,kBAAA;EAGA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;AAfJ;;AAkBA;EACI,WAAA;EACA,yBAAA;AAfJ;;AAkBA;EACI,aAAA;EACA,uBAAA;AAfJ;;AAkBA;EACI,YAAA;AAfJ;;AAkBA;EACI,cAAA;AAfJ;;AAkBA;EACI,gCAAA;EACA,8BAAA;EACA,+BAAA;AAfJ;;AAkBA;EACI,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAfJ;;AAkBA;EACI,iBAAA;AAfJ;;AAkBA;EACI,iBAAA;AAfJ","sourcesContent":["// .card.card-profile {\r\n//     z-index: 5;\r\n// }\r\n\r\n// .section-profile-cover {\r\n//     height: 470px;\r\n// }\r\n.card-profile {\r\n    min-height: calc(100vh - 24.3rem);\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n    .section-profile-cover {\r\n        height: 300px;\r\n    }\r\n}\r\n\r\n\r\n// .btn-warning {\r\n//     opacity: .8;\r\n// }\r\n\r\n.btn-disconnect {\r\n    background-color: #5d43ae;\r\n    color: #fff;\r\n}\r\n\r\n.disabilities_container {\r\n    font-size: 1.5rem;\r\n}\r\n\r\n.headings {\r\n    // background-color: #fff3cd;\r\n    letter-spacing: 1px;\r\n    border-radius: 5px;\r\n    // background-color: #593faa;\r\n    // color: #fff;\r\n    padding: 1rem 0;\r\n    font-weight: 500;\r\n    margin-top: 1.5rem;\r\n    margin-bottom: 0.5rem;\r\n    background-color: #a998d7;\r\n    color: #000;\r\n}\r\n\r\n.badge-secondary {\r\n    color: #fff;\r\n    background-color: #6449b3;\r\n}\r\n\r\ntd.info-cell {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.check-icon {\r\n    color: green\r\n}\r\n\r\n.error-icon {\r\n    color: #f44336;\r\n}\r\n\r\n.map-card {\r\n    border-bottom: solid 2px #3f51b5;\r\n    border-bottom-left-radius: 3px;\r\n    border-bottom-right-radius: 3px\r\n}\r\n\r\n.no-caretaker-container {\r\n    min-height: 116px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    letter-spacing: 0.625px;\r\n    flex-grow: 1;\r\n}\r\n\r\n.map-small { \r\n    min-height: 300px;\r\n}\r\n\r\n.map-expanded { \r\n    min-height: 390px;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
